import Html from './img/Html.png'
import Css from './img/Css.png'
import Js from './img/Js.png'
import Rails from './img/rails.png'
import Node from './img/Nodejs.png'
import React from './img/React.png'
import VsCode from './img/VsCode.png'
import Vuejs from './img/Vuejs.png'
import Php from './img/php.png'
import Mysql from './img/mysql.png'
import Typescript from './img/typescript.png'
import Postgresql from './img/postgresql.png'
import Java from './img/java.png'
import Firebase from './img/Firebase.png'
import Git from './img/Git.png'
import Gitlab from './img/gitlab.png'
import Github from './img/Github.png'
import Ionic from './img/ionic.png'
import Angular from './img/Angular.png'
import Photoshop from './img/Photoshop.png'
import Bootstrap from './img/Boostrap.png'

const SskData = [
  {
    src: Html,
  },
  {
    src: Css,
  },
  {
    src: Bootstrap,
  },
  {
    src: Photoshop,
  },
  {
    src: Js,
  },
  {
    src: Typescript
  },
  {
    src: React,
  },
  {
    src: Rails,
  },
  {
    src: Ionic,
  },
  {
    src: Angular,
  },
  {
    src: Vuejs,
  },
  {
    src: Node,
  },
  {
    src: Mysql,
  },
  {
    src: Postgresql,
  },
  {
    src: Php,
  },
  {
    src: Firebase,
  },
  {
    src: Java,
  },
  {
    src: VsCode,
  },
  {
    src: Git,
  },
  {
    src: Github,
  },
  {
    src: Gitlab,
  },
]
export default SskData
